import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import FormTitle from './FormTitle';

interface FormType {
  name: string;
  phoneNumber: string;
  insuranceType: string;
  insuranceName: string;
  // address: string;
  hospitalAddress: string;
  accidentType: string;
  insuranceAmount: string;
  description: string;
}

interface InformationFormPropsType {
  form: FormType;
  setForm: Dispatch<SetStateAction<FormType>>;
}

const InformationForm = ({ form, setForm }: InformationFormPropsType) => {
  const formatPhoneNumber = (input: string): string => {
    const raw = input.replace(/\D/g, ''); // 숫자만 추출

    if (raw.length <= 3) return raw;
    if (raw.length <= 7) return `${raw.slice(0, 3)}-${raw.slice(3)}`;
    return `${raw.slice(0, 3)}-${raw.slice(3, 7)}-${raw.slice(7, 11)}`;
  };

  const isValidPhoneNumber = (phone: string): boolean => {
    return /^010-\d{4}-\d{4}$/.test(phone);
  };

  return (
    <Wrapper>
      <InputBlock>
        <FormTitle title="상담을 위해 고객님의 정보가 필요해요" />
        <InputWrapper style={{ marginTop: 28 }}>
          <InputLabel htmlFor="name">이름</InputLabel>
          <StyledInput
            id="name"
            type="text"
            value={form.name}
            onChange={(e) =>
              setForm((prev) => ({
                ...prev,
                name: e.target.value,
              }))
            }
            placeholder="이름을 입력하세요"
            required
          />
        </InputWrapper>
      </InputBlock>

      <InputBlock>
        <InputWrapper>
          <InputLabel htmlFor="phoneNumber">연락처</InputLabel>
          <PhoneRow>
            <StyledInput
              id="phoneNumber"
              type="text"
              value={form.phoneNumber}
              onChange={(e) => {
                const formatted = formatPhoneNumber(e.target.value);

                if (formatted.replace(/\D/g, '').length >= 11 && !isValidPhoneNumber(formatted)) {
                  alert('❌ 잘못된 연락처 형식입니다.\n예: 010-1234-5678');
                  return;
                }

                setForm((prev) => ({
                  ...prev,
                  phoneNumber: formatted,
                }));
              }}
              placeholder="010-1234-5678 형식으로 입력하세요"
              required
            />
          </PhoneRow>
        </InputWrapper>
      </InputBlock>
    </Wrapper>
  );
};

export default InformationForm;

// ======================= styled-components =======================

const Wrapper = styled.div`
  width: 100%;
  display: grid;
  gap: 11px;
  align-items: flex-end;
  @media (min-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 14px; /* sm:gap-3.5 */
  }
`;

const InputBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

const InputWrapper = styled.div`
  position: relative;
  /* margin-top: 28px; */
`;

const InputLabel = styled.label`
  position: absolute;
  top: 16px;
  left: 24px;
  font-size: 12px;
  font-weight: 500;

  @media (min-width: 640px) {
    font-size: 14px;
  }
`;

const StyledInput = styled.input`
  width: 100%;
  height: 72px;
  padding: 35px 24px 16px;
  background-color: #f6f7fb; /* bg-gray-100 */
  border-radius: 16px;
  border: none;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  outline: none;
  @media (min-width: 640px) {
    height: 82px;
    font-size: 18px;
    line-height: 27px;
  }

  &::placeholder {
    font-weight: 300; /* font-light */
    color: #999;
  }

  &:focus {
    border: 1px solid #0b46dd; /* focus:border-blue-200 */
  }
`;

const PhoneRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
